export const commContent = {
    fr: {
        eyebrow: 'LE PROCESSUS',
        title: 'Comment ça marche ?',
        steps: [
            { title: 'Passer votre commande', body: "Passez commande en choisissant l'abonnement qui vous convient." },
            { title: 'Recevez votre accès', body: 'Après le paiement, vous recevrez par e-mail en moins de 10 minutes vos identifiants et un guide d\'installation.' },
            { title: 'Profitez de votre IPTV', body: 'Profitez dès maintenant de toutes les chaînes, films et séries !' },
        ],
        ctaTitle: 'Choisissez le fournisseur IPTV n°1 en Europe',
        ctaButton: 'Acheter maintenant',
    },
    es: {
        eyebrow: 'EL PROCESO',
        title: '¿Cómo funciona?',
        steps: [
            { title: 'Haz tu pedido', body: 'Haz tu pedido eligiendo la suscripción que mejor se adapte a ti.' },
            { title: 'Recibe tu acceso', body: 'Tras el pago, recibirás por email en menos de 10 minutos tus credenciales y una guía de instalación.' },
            { title: 'Disfruta de tu IPTV', body: '¡Disfruta ya de todos los canales, películas y series!' },
        ],
        ctaTitle: 'Elige el proveedor IPTV n.º 1 de Europa',
        ctaButton: 'Comprar ahora',
    },
};
